<div class="ui attached segment" appMargin marginT="5">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
    <!-- <div fxFlex="5%">
             <sui-checkbox >
              </sui-checkbox>
      </div> -->

    <div fxFlex="30">{{ file?.name }}</div>
    <div fxFlex="40">{{ file?.description }}</div>
    <div fxFlex fxLayoutGap="10px" class="text-right">
      <button
        class="ui circular tiny button"
        (click)="editUnit.emit(file)"
        suiPopup
        [popupInverted]="true"
        popupPlacement="bottom"
        popupText="Edit Settings"
        *ngIf="
          checkPermission({
            id: 'APPLICATION_SECURITY_MODULE',
            action: 'edit'
          })
        "
      >
        <i class="pen icon"></i>
      </button>

      <button
        *ngIf="file?.fileSettingsId !== 'file_concurrent_uploads'"
        class="ui circular tiny button"
        (click)="toggleEquipment()"
        suiPopup
        [popupInverted]="true"
        popupPlacement="bottom"
        [popupText]="collapseEquipment ? 'Expand' : 'Collapse'"
      >
        <i
          [ngClass]="
            collapseEquipment ? 'chevron down icon' : 'chevron up icon'
          "
        ></i>
      </button>
    </div>
  </div>
</div>

<div [suiCollapse]="collapseEquipment">
  <div
    class="ui bottom attached segment"
    appPadding="0"
    [ngClass]="{ loading: pending }"
  >
    <app-file-setting
      [file]="file"
      [settings]="settings"
      (onEdit)="editUnit.emit($event)"
      (onView)="onViewUnit($event)"
    ></app-file-setting>
  </div>
</div>
